import React, { useState, useEffect } from 'react'

import { Grid, Typography, Box } from '@mui/material';

import { CoreContext } from '../../../core/context/CoreContext';
import PageWaiting from '../../../core/components/PageWaiting';
import IconEnabled from '../../../core/components/layout/IconEnabled';
import IconDisabled from 'core/components/layout/IconDisabled';
import { useDispatch, useSelector } from 'react-redux';
import ProductListTableHeader from './ProductListTableHeader';
import ProductListTableRow from './ProductListTableRow';

export default function ProductListTable({ payload }) {

  const { showloading } = React.useContext(CoreContext);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const {userprofileInfo} = useSelector((state)=>state.headerslice);
  const {productList, productDashboard} = useSelector((state)=>state.pharmaslice)
  const {pharmaorderObj} = useSelector((state)=>state.pharmaslice.pharmaorderDashboard);

  useEffect(() => {
    setRows(payload.tableList);
  }, [payload])
  

  const handleRowClick = (rowId) => {
    setRows(prevData =>
      prevData.map(item =>
        item.id === rowId ? { ...item, 'expand': !item.expand } : item
      )
    );
  }
  

  const getActionComponent = (rowObj) => {
    return <>
      {
        payload.actionList.map(actionObj => {
          //console.log("actionObj=>"+actionObj.title+" Status=>"+actionObj.status+" Role=>"+actionObj.role)
          if (
            (
              actionObj.status===undefined || (
                  actionObj.status!==undefined && 
                  (actionObj.status==='' || (actionObj.status!=='' && actionObj.status.toLowerCase().includes(rowObj.statusname.toLowerCase())))
              )
            )
          && 
          (actionObj.role===undefined || actionObj.role!=undefined && (actionObj.role==='' || actionObj.role.includes(userprofileInfo.rolename)))
        )
            return <IconEnabled actionObj={actionObj} id={rowObj.id} />
        })}
    </>
  }

  return (
    <>
      <Grid container direction="column" sx={{ justifyContent: "flex-start", alignItems: "flex-start", }}>
        {/* <HEADER/> */}
        <Grid item sx={{ width: '100%', paddingBottom: .2 }}>
          {/* <HEADER - CONTAINER/> */}
          < ProductListTableHeader />
        </Grid>
        {/* <ROWS/> */}
        <Grid item sx={{ width: '100%' }}>
          <Box lg={12} sx={{ flexGrow: 1 }}>
            <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', height: pharmaorderObj.id===undefined?'60vh':{lg:'40vh', md:'50vh', sm:'50vh', xs:'50vh'} }}>
              {/* <ROW CONTAINER/> */}
              <Grid
                container
                direction="column"
                sx={{
                  justifyContent: rows.length === 0 ? "center" : "flex-start", // Center if empty
                  alignItems: "center", // Center horizontally
                  width: '100%',
                  position: 'relative',
                  minHeight: 300, // Ensure enough height for vertical centering
                }}
              >

                {rows.map(obj => {
                  return (
                    <ProductListTableRow key={obj.id} obj={obj} getActionComponent={getActionComponent} actionList={payload.actionList} handleRowClick={handleRowClick} />
                  )
                })}

                {
                  rows.length === 0 ?
                    <Box
                      sx={{
                        width: '50%',
                        maxWidth: 400,
                        minWidth: 200,
                        height: 200,
                        backgroundColor: 'secondary.100',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: 2,
                        boxShadow: 1,
                      }}
                    >
                      <Typography sx={{ fontWeight: 400, fontSize: 16, color: 'text.secondary', textAlign: 'center' }}>
                        List is empty
                      </Typography>
                    </Box>
                    : <></>
                }

              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </>
  );


}